import React, { useState } from "react"
import PropTypes from "prop-types"
import Dialog from "@material-ui/core/Dialog"
import Slide from "@material-ui/core/Slide"
import DialogContent from "@material-ui/core/DialogContent"
import RoundedClose from "../../images/close.png"
import { AppFormContainer } from "../formContainer"
import Input from "../formContainer/input"
import Textarea from "../formContainer/textarea"
import DatePicker from "../formContainer/datePicker"
import * as moment from "moment"
import Select from "../formContainer/select"
import MenuItem from "@material-ui/core/MenuItem"
import Radio from "../formContainer/radio"
import axios from "axios"
import { RichText } from "prismic-reactjs"
import "./index.scss"

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

export const BookSeminarModal = ({ open, onClose, selectedDuration, pathContext, data }) => {
  const [date, setDate] = useState("")
  const [name, setName] = useState("")
  const [mobile, setMobile] = useState("")
  const [email, setEmail] = useState("")
  const [adults, setAdults] = useState(0)
  const [children, setChildren] = useState(0)
  const [duration, setDuration] = useState(selectedDuration)
  const [observations, setObservations] = useState("")

  // console.log("data", data)

  const getParentData = () => {
    return data && data.prismic && data.prismic.allCreate_your_own_heidi_pages && data.prismic.allCreate_your_own_heidi_pages.edges && data.prismic.allCreate_your_own_heidi_pages.edges[0] && data.prismic.allCreate_your_own_heidi_pages.edges[0].node
  }

  const submit = (e) => {
    e.preventDefault()
    // console.log(Array.from(e.target.elements))
    // fetch("https://us-central1-heidi-55913.cloudfunctions.net/bookSeminar", {
    const params = {
      name: name,
      phoneNumber: mobile,
      email: email,
      date: date,
      adults: adults,
      children: children,
      hours: duration,
      observations: observations,
      locale: pathContext.lang
    }
    // console.log(params)
    axios({
      method: "post",
      // url: "http://localhost:5001/heidi-55913/us-central1/bookSeminar",
      url: "https://us-central1-heidi-55913.cloudfunctions.net/bookSeminar",
      data: params
    }).then(response => {
      // console.log(response)
      onClose()
    }).catch(()=>{
      // console.log();
      onClose()
    })
  }

  return (
    <Dialog fullScreen open={open} onClose={onClose} TransitionComponent={Transition}>
      <DialogContent className="app-book-seminar-modal">
        <div className="app-book-seminar-content">
          <div className="d-flex justify-content-end">
            <button className="close-button" onClick={onClose}>
              <img src={RoundedClose} alt="close-modal"/>
            </button>
          </div>
          <div
            className="text-center">{getParentData() && getParentData().book_seminar_form_title && getParentData().book_seminar_form_title[0] && RichText.render(getParentData().book_seminar_form_title)}</div>
          <div
            className="text-center">{getParentData() && getParentData().book_seminar_form_description && getParentData().book_seminar_form_description[0] && RichText.render(getParentData().book_seminar_form_description)}</div>
          <form onSubmit={submit}>

            <AppFormContainer className="mt-4 mt-sm-3">
              <Input
                name="name"
                type="text"
                value={name}
                onChange={e => setName(e.target.value)}
                placeholder={getParentData() && getParentData().name_input_label}/>

              <Input
                name="mobile"
                type="tel"
                value={mobile}
                onChange={e => setMobile(e.target.value)}
                placeholder={getParentData() && getParentData().phone_number_input_label}/>

              <Input
                name="email"
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder={getParentData() && getParentData().email_input_label}/>
            </AppFormContainer>

            <div className="text-center my-4 my-sm-3 font-weight-bold ">{getParentData() && getParentData().date_and_time_title}</div>

            <DatePicker
              exteriorIcon
              showTimeSelect
              inputWidth="90%"
              name="date-time"
              timeFormat="HH:mm"
              dateFormat="MMMM d, yyyy h:mm aa"
              minDate={moment().toDate()}
              selected={date}
              locale={pathContext.lang && pathContext.lang.indexOf("en") === -1 ? pathContext.lang : undefined}
              onChange={d => setDate(d)}
              placeholderText={getParentData() && getParentData().date_and_time_selector_placeholder}
            />

            <div className="text-center font-weight-bold mt-4 mt-sm-3">{getParentData() && getParentData().seminar_duration_title}</div>
            <div className="d-flex justify-content-center mt-4 mt-sm-2">
              <div className="mr-2">
                <Radio
                  checked={duration === 1}
                  onClick={() => setDuration(1)}
                  value="a"
                  name="radio-button-demo"
                  inputProps={{ "aria-label": "A" }}
                /> 2 {getParentData() && getParentData().hours_input_label}
              </div>
              <div className="ml-2">
                <Radio
                  checked={duration === 2}
                  onClick={() => setDuration(2)}
                  value="b"
                  name="radio-button-demo"
                  inputProps={{ "aria-label": "A" }}
                /> 1 {getParentData() && getParentData().hours_input_label}
              </div>
            </div>
            <div className="text-center mt-4 mt-sm-2 font-weight-bold">{getParentData() && getParentData().number_of_attendees_title}</div>
            <div className="d-flex mt-4">
              <div className="col d-flex align-items-center select-wrapper">
                {/*<div>*/}
                <Select value={adults} onChange={(e) => setAdults(e.target.value)}>
                  {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15].map((n, index) => (<MenuItem key={index.toString()} value={n}>{n}</MenuItem>))}
                </Select>
                {/*</div>*/}
                <div className="col d-flex justify-content-center align-items-center font-gilroy-medium" style={{ marginBottom: 10 }}>
                  {getParentData() && getParentData().adults_input_label}
                </div>
              </div>
              <div className="col d-flex justify-content-center select-wrapper">
                {/*<div className="d-flex justify-content-center">*/}
                {/*  <div>*/}
                <Select value={children} onChange={(e) => setChildren(e.target.value)}>
                  {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15].map((n, index) => (<MenuItem key={index.toString()} value={n}>{n}</MenuItem>))}
                </Select>
                <div className="d-flex flex-column justify-content-center">
                  {getParentData() && getParentData().children_input_label}
                  <small><i>{getParentData() && getParentData().minimum_age_text}</i></small>
                </div>
                {/*</div>*/}
                {/*<div className="col d-flex flex-column justify-content-center align-items-center font-gilroy-medium" style={{ marginBottom: 10 }}>*/}
                {/*  Children*/}
                {/*  <small><i>Minimum age 8 years old</i></small>*/}
                {/*</div>*/}
                {/*</div>*/}
              </div>
            </div>
            {/*<div className="d-flex justify-content-end">*/}
            {/*  <div>*/}
            {/*    <small><i>Minimum ange 8 years old</i></small>*/}
            {/*  </div>*/}
            {/*</div>*/}

            <AppFormContainer className="mt-4 mt-sm-3" showButton buttonText={getParentData() && getParentData().seminar[0].button_text}>
              <Textarea
                value={observations}
                onChange={(e) => {
                  setObservations(e.target.value)
                }}
                placeholder={getParentData() && getParentData().message_input_label}
              />
            </AppFormContainer>
          </form>
        </div>
      </DialogContent>
    </Dialog>
  )
}

BookSeminarModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
}
